import { TemporaryTokenManager } from '@cobliteam/api-lib/src/account/cobler/TemporaryTokenManager';
import { SessionManager } from '@cobliteam/api-lib/src/account/session/SessionManager';
import type { AccessibleFleet, Session } from '@cobliteam/common-types';
import useAuthStore from '@cobliteam/hooks/src/useSession/store/useAuthStore';
import { Environment } from '@cobliteam/react-environments';
import Alert from '@cobliteam/ui/components/Alert';
import { useMutation } from '@tanstack/react-query';

const env = Environment.getInstance().getEnvironment();
const sessionManager = new SessionManager({ host: env.herbieApiHost });

/**
 * Troca a frota logada. Após sucesso, limpa o temporary token e recarrega a app no root — igual ao
 * antigo `changeUserFleetSaga`. O reload garante que todas as queries e stores hidratem no contexto
 * da nova frota.
 *
 * Antes do reload, também limpa o snapshot persistido de `userData` no `useAuthStore`.
 */
const useChangeFleet = () => {
  return useMutation<Session, unknown, AccessibleFleet>({
    mutationFn: (userFleet) => sessionManager.changeUserLoggedFleet(userFleet),
    onSuccess: () => {
      useAuthStore.getState().clearUserData();
      TemporaryTokenManager.deleteTemporaryToken();
      window.location.href = '/';
    },
    onError: () => Alert.error('Houve um erro ao tentar trocar de frota'),
  });
};

export default useChangeFleet;
